import React from 'react';
import Style from './badge.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Badge = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.color = Style[props.color === undefined ? 'success' : props.color];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("span", {
      onClick: props.onClick,
      className: `${Style.badge} ${propsArray.color}`,
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("span", {
      onClick: props.onClick,
      className: `${Style.badge} ${propsArray.color} ${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

export default Badge;